/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbStatutSocialDto
 */
export interface FcbStatutSocialDto {
    /**
     * 
     * @type {number}
     * @memberof FcbStatutSocialDto
     */
    idstatutSocial?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbStatutSocialDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbStatutSocialDto
     */
    idstatutSocialGuid?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbStatutSocialDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbStatutSocialDto interface.
 */
export function instanceOfFcbStatutSocialDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbStatutSocialDtoFromJSON(json: any): FcbStatutSocialDto {
    return FcbStatutSocialDtoFromJSONTyped(json, false);
}

export function FcbStatutSocialDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbStatutSocialDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idstatutSocial': !exists(json, 'idstatutSocial') ? undefined : json['idstatutSocial'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'idstatutSocialGuid': !exists(json, 'idstatutSocialGuid') ? undefined : json['idstatutSocialGuid'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbStatutSocialDtoToJSON(value?: FcbStatutSocialDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idstatutSocial': value.idstatutSocial,
        'libelle': value.libelle,
        'idstatutSocialGuid': value.idstatutSocialGuid,
        'actif': value.actif,
    };
}

